const CryptoJS = require("crypto-js");
const AES = require("crypto-js/aes");
const SHA256 = require("crypto-js/sha256");

const Enigma = {
  encryptObj(obj) {
    const result = CryptoJS.AES.encrypt(
      JSON.stringify(obj),
      process.env.VUE_APP_SECRET
    );

    return result.toString();
  },
  decryptObj(obj) {
    const bytes = CryptoJS.AES.decrypt(obj, process.env.VUE_APP_SECRET);
    const decryptedData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
    return decryptedData;
  },
  // encrypt(text) {
  //   const res = CryptoJS.AES.encrypt(text, "finrax payments key");
  //   return res.toString();
  // },
  // decrypt(text) {
  //   let bytes = CryptoJS.AES.decrypt(text, "finrax payments key");
  //   return bytes.toString(CryptoJS.enc.Utf8);
  // }
};

export default Enigma;
